// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var TokenDialogController = function ($scope, $modalInstance, token) {
    $scope.token = token;

    $scope.close = function () {
        $modalInstance.close();
    };
};
TokenDialogController.$inject = ['$scope', '$uibModalInstance', 'token'];
